"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonUtils = void 0;
const tslib_1 = require("tslib");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const common_1 = require("../error/common");
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
class JSONUtils {
    parseJSON(content) {
        try {
            const obj = JSON.parse(content);
            return (0, teamsfx_api_1.ok)(obj);
        }
        catch (e) {
            return (0, teamsfx_api_1.err)(new common_1.JSONSyntaxError(content, e));
        }
    }
    async readJSONFile(filePath) {
        try {
            const res = await fs_extra_1.default.readJSON(filePath);
            return (0, teamsfx_api_1.ok)(res);
        }
        catch (e) {
            if (e.name === "SyntaxError") {
                const error = new common_1.JSONSyntaxError(filePath, e);
                return (0, teamsfx_api_1.err)(error);
            }
            else if (e.message?.includes("no such file or directory")) {
                return (0, teamsfx_api_1.err)(new common_1.FileNotFoundError("common", filePath));
            }
            return (0, teamsfx_api_1.err)(new common_1.ReadFileError(e, "common"));
        }
    }
    readJSONFileSync(filePath) {
        try {
            const res = fs_extra_1.default.readJSONSync(filePath);
            return (0, teamsfx_api_1.ok)(res);
        }
        catch (e) {
            if (e.name === "SyntaxError") {
                const error = new common_1.JSONSyntaxError(filePath, e);
                return (0, teamsfx_api_1.err)(error);
            }
            else if (e.message?.includes("no such file or directory")) {
                return (0, teamsfx_api_1.err)(new common_1.FileNotFoundError("common", filePath));
            }
            return (0, teamsfx_api_1.err)(new common_1.ReadFileError(e, "common"));
        }
    }
}
exports.jsonUtils = new JSONUtils();
//# sourceMappingURL=jsonUtils.js.map